import { Trigger } from 'src/app/models/trigger';

import { Content } from 'src/app/models/content';
import { QuestionSelect } from 'src/app/models/question-select';
import { QuestionText } from 'src/app/models/question-text';
import { QuestionRating } from 'src/app/models/question-rating';
import { CtaSimple } from 'src/app/models/cta-simple';
import { MessageSimple } from 'src/app/models/message-simple';
import { FormOverlay } from 'src/app/models/form-overlay';
import { Form } from 'src/app/models/form';
import { Video } from './video';

export class ContentList{

  legacy:boolean = false; // 旧フォームの場合:true ※trueの場合、変更不可、保存しない
  hash:string;

  type:string = "ContentList";
  startAt:string;
  startTrigger:Trigger; // このContentList内の何を最初に実行するかのTrigger
  // trigger:Trigger; // このContentListが終わったときの次のTrigger
  contents:Array<any> = [];
  parentVideo:Video;
  parentTrigger:Trigger; // このContentListをトリガーしたトリガー
  
  constructor(object = null){
    this.hash = this.generateHash();

    if(object){
      this.set(object);
    }
  };

  set(object){

    if(object.legacy){
      this.legacy = object.legacy;
    }

    if(object.hash){
      this.hash = object.hash;
    }

    let startAtContent;
    if(object.contents){
      for(let contentObject of object.contents){

        let content:any;
        if(contentObject.type == 'QuestionSelect'){
          content = new QuestionSelect(contentObject);
        }
        if(contentObject.type == 'QuestionText'){
          content = new QuestionText(contentObject);
        }
        if(contentObject.type == 'QuestionRating'){
          content = new QuestionRating(contentObject);
        }
        if(contentObject.type == 'CtaSimple'){
          content = new CtaSimple(contentObject);
        }
        if(contentObject.type == 'MessageSimple'){
          content = new MessageSimple(contentObject);
        }
        if(contentObject.type == 'FormOverlay'){
          content = new FormOverlay(contentObject);
          if(content.form.isVisitorOnly == Form.IsVisitorOnlyTrue){
            // すでにProspect化している人には表示しない
            if(window.onerollTrack && window.onerollTrack.isProspect){
              continue;
            }
          }
        }

        if(! content){
          continue;
        }

        content.parentContentList = this;
        this.contents.push(content);

        if(object.startAt){
          if(content.hash == object.startAt){
            this.setStartAtContent(content);
          }
        }    
      }
    }


  }

  setStartAtContent(content){
    this.startAt = content.hash;
    this.startTrigger = new Trigger();
    if(this.legacy){
      this.startTrigger.legacy = true;
    }
    this.startTrigger.baseContent = this;
    this.startTrigger.nextType = "MainContent";
    this.startTrigger.nextMainContentHash = this.startAt;

    content.addParentTrigger(this.startTrigger);
  }
  
  getContent(contentHash){
    for(let index in this.contents){
      if(this.contents[index].hash == contentHash){
        return this.contents[index];
      }
    }
  }

  isMainContent(){
    return false;
  }
  isSubContent(){
    return false;
  }

  // 分岐のないContentListの場合、項目数を返す
  // 分岐があればfalseを返す
  getSubContentsCountForOnlyNoBranch(){

    for(var i = 0; i < this.contents.length; i++){
      var content = this.contents[i];
      if(content.type != "QuestionSelect"){
        continue;
      }
      // questionSelectを含んでいる場合
      for(var j = 0; j < content.options.length; j++){
        var option = content.options[j];
        if(! option.trigger){
          continue;
        }
        // optionにtriggerが設定してある場合
        return false;
      }
    }
    return this.contents.length;
  }



  static comparePartIndex(a, b) {
    const aSeconds = a.startTrigger.seconds;
    const bSeconds = b.startTrigger.seconds;  
    let comparison = 0;
    if (aSeconds > bSeconds) {
      comparison = 1;
    } else if (aSeconds < bSeconds) {
      comparison = -1;
    }
    return comparison;
  }

  generateHash(){
    // 生成する文字列の長さ
    var l = 12;

    // 生成する文字列に含める文字セット
    var c = "abcdefghijklmnopqrstuvwxyz0123456789";

    var cl = c.length;
    var r = "";
    for(var i=0; i<l; i++){
      r += c[Math.floor(Math.random()*cl)];
    }
    return r;
  }  
}